'use strict';

bbw.service.LayoutTypeSvc = Class({

    statics: {
        LAYOUT_TYPES: [
            'desktop',
            'tablet',
            'mobile'
        ],
        MAP: {
            1: 'mobile',
            2: 'tablet',
            3: 'desktop'
        }
    },

    $inject: ['$window', '$rootScope'],

    $window: undefined,

    _element: undefined,
    _layoutType: undefined,
    _watchersRegistered: false,

    construct: function($window, $rootScope) {
        this.$window = $window;
        this._reset = function() {
            if (angular.isDefined(this._layoutType)) {
                this._layoutType = undefined;
                $rootScope.$safeApply();
            }
        }.bind(this);
    },

    hasTouch: function() {
        return 'ontouchstart' in document.documentElement;
    },

    isMobile: function() {
        return 'mobile' === this.getLayoutType();
    },

    isTablet: function() {
        return 'tablet' === this.getLayoutType();
    },

    isDesktop: function() {
        return 'desktop' === this.getLayoutType();
    },

    setElement: function(el) {
        this._element = el;
        this._registerWatchers();
    },

    unsetElement: function(el) {
        if (angular.isUndefined(el) || el === this._element) {
            this._unregisterWatchers();
            this._element = undefined;
        }
    },

    getLayoutType: function() {
        var layoutTypes = bbw.service.LayoutTypeSvc.LAYOUT_TYPES;

        if (angular.isUndefined(this._layoutType)) {
            this._layoutType = this._detectLayoutType();
            if (layoutTypes.indexOf(this._layoutType) < 0) {
                this._layoutType = undefined;
            }
        }

        return this._layoutType || layoutTypes[0];
    },

    _detectLayoutType: function() {
        if (angular.isUndefined(this._element)) {
            return undefined;
        }
        try {
            var idx = this.$window.getComputedStyle(this._element).top.match(/^-([0-9])/)[1];
            return bbw.service.LayoutTypeSvc.MAP[idx];
        } catch (e) {
            return undefined;
        }
    },

    _registerWatchers: function() {
        window.addEventListener('resize', this._reset);
    },

    _unregisterWatchers: function() {
        window.removeEventListener('resize', this._reset);
    }

});

